// extracted by css-extract-rspack-plugin
export default {"animate-spin-ckpt":"animate-spin-ckpt-G7trEF","animateSpinCkpt":"animate-spin-ckpt-G7trEF","wait":"wait-KvM88u","bgHover":"bgHover-TbmMqU"};